/* Solo product page: gallery, variants, bundle tiers, free gift, sticky bar. No dependencies. */
(function () {
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return (cents / 100).toFixed(2);
    function group(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = group(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = group(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = group(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = group(cents, 2, "'", '.'); break;
      default: v = group(cents, 2, ',', '.');
    }
    return fmt.replace(m[0], v).replace(/<[^>]*>/g, '');
  }

  function initGallery(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = root.querySelectorAll('[data-thumbs] [data-go]');
    var count = root.querySelector('[data-count]');
    var current = 0;
    function mark(i) {
      current = i;
      if (count) count.textContent = i + 1;
      Array.prototype.forEach.call(thumbs, function (b, j) {
        b.classList.toggle('is-active', j === i);
        if (j === i && b.scrollIntoView && b.parentNode.scrollWidth > b.parentNode.clientWidth) {
          var p = b.parentNode;
          p.scrollTo({ left: b.offsetLeft - p.clientWidth / 2 + b.clientWidth / 2, behavior: 'smooth' });
        }
      });
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
    }
    root.goToMedia = function (id) {
      slides.forEach(function (s, j) { if (String(s.dataset.mediaId) === String(id)) go(j); });
    };
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-go]');
      if (b) { go(parseInt(b.dataset.go, 10)); return; }
      if (e.target.closest('[data-prev]')) go(current - 1);
      if (e.target.closest('[data-next]')) go(current + 1);
    });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { mark(Math.round(track.scrollLeft / (track.clientWidth || 1))); }, 60);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(current + 1);
      if (e.key === 'ArrowLeft') go(current - 1);
    });
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    var form = root.querySelector('[data-solo-form]');
    if (!dataEl || !form) return;
    var data = JSON.parse(dataEl.textContent);
    var gallery = root.querySelector('[data-gallery]');
    var idInput = form.querySelector('[data-variant-id]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saveEl = root.querySelector('[data-save]');
    var atc = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyBtn = root.querySelector('[data-sticky-btn]');
    var errEl = root.querySelector('[data-err]');
    var tiersEl = form.querySelector('[data-tiers]');
    var mixEl = form.querySelector('[data-mix]');
    var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    var current = null;

    function money(c) { return formatMoney(c, data.money_format); }
    function selected() {
      return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function findVariant(opts) {
      if (!fieldsets.length) {
        var cur = String(idInput.value);
        return data.variants.find(function (x) { return String(x.id) === cur; }) || data.variants[0];
      }
      return data.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function tier() {
      if (!tiersEl) return { n: 1, pct: 0 };
      var r = tiersEl.querySelector('input[name^="tier-"]:checked');
      return r ? { n: parseInt(r.value, 10) || 1, pct: parseInt(r.dataset.pct, 10) || 0 } : { n: 1, pct: 0 };
    }
    function total(price, n, pct) {
      return n * (price - Math.floor(price * pct / 100));
    }
    function refreshTiers() {
      if (!current) return;
      var p = current.price;
      if (tiersEl) {
        Array.prototype.forEach.call(tiersEl.querySelectorAll('.solo-tier'), function (lab) {
          var r = lab.querySelector('input');
          var n = parseInt(r.value, 10), pct = parseInt(r.dataset.pct, 10) || 0;
          var tot = total(p, n, pct);
          var tEl = lab.querySelector('[data-tier-total]'); if (tEl) tEl.textContent = money(tot);
          var fEl = lab.querySelector('[data-tier-full]'); if (fEl) fEl.textContent = money(p * n);
          var eEl = lab.querySelector('[data-tier-each]'); if (eEl) eEl.textContent = money(Math.floor(tot / n));
          lab.classList.toggle('is-active', r.checked);
        });
      }
      var t = tier();
      var sum = total(p, t.n, t.pct);
      if (atcPrice) atcPrice.textContent = money(sum);
      if (stickyPrice) stickyPrice.textContent = money(sum);
      if (qtyInput) qtyInput.value = t.n;
      if (mixEl) {
        mixEl.hidden = t.n < 2;
        Array.prototype.forEach.call(mixEl.querySelectorAll('[data-mix-row]'), function (row) {
          row.hidden = parseInt(row.dataset.mixRow, 10) > t.n;
        });
      }
    }
    function syncMix(color) {
      if (!mixEl) return;
      Array.prototype.forEach.call(mixEl.querySelectorAll('[data-mix-row] input'), function (inp) {
        inp.checked = inp.value === color;
      });
    }
    function update(fromOption) {
      var opts = selected();
      fieldsets.forEach(function (fs, i) {
        var lbl = fs.querySelector('[data-option-value]');
        if (lbl) lbl.textContent = opts[i] || '';
        if (fs.classList.contains('solo-tiers--opt')) {
          Array.prototype.forEach.call(fs.querySelectorAll('.solo-tier'), function (lab) {
            var r = lab.querySelector('input'); lab.classList.toggle('is-active', !!(r && r.checked));
          });
        }
      });
      var v = findVariant(opts);
      current = v || null;
      if (!v) {
        atc.disabled = true; atcText.textContent = data.unavailable;
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      compareEl.hidden = !onSale; saveEl.hidden = !onSale;
      if (onSale) {
        compareEl.textContent = money(v.compare_at_price);
        saveEl.textContent = data.save + ' ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      }
      atc.disabled = !v.available; atcText.textContent = v.available ? data.atc : data.soldout;
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (fromOption && data.color_index >= 0) syncMix(opts[data.color_index]);
      refreshTiers();
      if (fromOption && v.media_id && gallery && gallery.goToMedia) gallery.goToMedia(v.media_id);
      try {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    form.addEventListener('change', function (e) {
      var inp = e.target;
      if (inp.closest('[data-option-index]')) update(true);
      else if (inp.name && inp.name.indexOf('tier-') === 0) refreshTiers();
    });

    function lines() {
      var t = tier();
      var counts = {};
      if (t.n > 1 && mixEl && data.color_index >= 0) {
        var base = selected();
        for (var n = 1; n <= t.n; n++) {
          var row = mixEl.querySelector('[data-mix-row="' + n + '"] input:checked');
          var opts = base.slice();
          if (row) opts[data.color_index] = row.value;
          var v = findVariant(opts) || current;
          if (!v || !v.available) return null;
          counts[v.id] = (counts[v.id] || 0) + 1;
        }
      } else {
        if (!current || !current.available) return null;
        counts[current.id] = t.n;
      }
      return Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
    }
    function fail(msg) {
      atc.removeAttribute('aria-busy'); atc.style.opacity = '';
      if (errEl) { errEl.textContent = msg || data.error; errEl.hidden = false; }
    }
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (errEl) errEl.hidden = true;
      var items = lines();
      if (!items) { fail(data.soldout); return; }
      atc.setAttribute('aria-busy', 'true'); atc.style.opacity = '.8';
      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var ready = data.gift_id
        ? fetch(root_url + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
            var has = cart.items.some(function (it) { return it.variant_id === data.gift_id; });
            if (!has) items.push({ id: data.gift_id, quantity: 1 });
          }).catch(function () { items.push({ id: data.gift_id, quantity: 1 }); })
        : Promise.resolve();
      ready.then(function () {
        return fetch(root_url + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) { fail(res.j && (res.j.description || res.j.message)); return; }
        window.location.href = root_url + (data.checkout ? 'checkout' : 'cart');
      }).catch(function () { fail(); });
    });

    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });

    var sticky = root.querySelector('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.solo-footer');
      var atcVisible = true, footerVisible = false;
      var set = function () {
        var on = !atcVisible && !footerVisible;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; set(); }).observe(atc);
      if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; set(); }).observe(footer);
    }
    update(false);
  }

  function init() {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-solo-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
